export default {
      id: "icon-euro-usage",
      viewBox: "0 0 79 79",
      url: __webpack_public_path__ + "icons.svg#icon-euro",
      toString: function () {
        return this.url;
      }
    }